import React from 'react';
import styles from '../internal_transfer/style.module.scss';
import classNames from 'classnames';
import DashboardWrapper from 'shared/components/common/dashboard_wrapper/DashboardWrapper';
import Heading from 'shared/components/common/heading/Heading';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import InnerSoTable from '../sale_order/InnerSoTable';

export default function ViewReturnOrder() {
    const location = useLocation();
    const data = location.state?.data;

    return (
        <DashboardWrapper>
            <div className={classNames(styles.UserContainer, 'text-start')}>
                <div className={styles.Header}>
                    <Heading heading={`Return Order Details: ${data?.order_number || 'N/A'}`} headingStyle={styles.Heading} />
                </div>

                <div className={styles.SelectionRow} style={{ flexWrap: 'wrap', gap: '20px' }}>
                    <div className={styles.DetailItem}>
                        <label className={styles.InputLabel}>Warehouse</label>
                        <div className={styles.DetailValue}>{data?.warehouse?.code || 'N/A'}</div>
                    </div>
                    <div className={styles.DetailItem}>
                        <label className={styles.InputLabel}>Date</label>
                        <div className={styles.DetailValue}>{moment(data?.created_at).format('DD, MMM YYYY HH:mm')}</div>
                    </div>
                    <div className={styles.DetailItem}>
                        <label className={styles.InputLabel}>Return Person</label>
                        <div className={styles.DetailValue}>{data?.returnPerson || 'N/A'}</div>
                    </div>
                    <div className={styles.DetailItem}>
                        <label className={styles.InputLabel}>Reference Number</label>
                        <div className={styles.DetailValue}>{data?.referenceNumber || 'N/A'}</div>
                    </div>
                    <div className={styles.DetailItem} style={{ width: '100%' }}>
                        <label className={styles.InputLabel}>Reason</label>
                        <div className={styles.DetailValue}>{data?.reason || 'N/A'}</div>
                    </div>
                </div>

                <div className={classNames(styles.Body, "mt-4")}>
                    <InnerSoTable
                        PoList={data?.items || []}
                        isView={true}
                    />
                </div>
            </div>
        </DashboardWrapper>
    );
}
